// extracted by mini-css-extract-plugin
module.exports = {"base-btn-light":"base-btn-light__praB_"};